
import { Component, Prop, Vue } from 'vue-property-decorator';
@Component
export default class NotFoundSvg extends Vue{
	@Prop({ default: 178 }) private size: number;
	get Height(): number{
		return this.size * (259/169);
	}
}
